module.exports = __webpack_public_path__ + "img/benefits.42812a2c.png";